import { render, staticRenderFns } from "./JBProposalStockRecords.vue?vue&type=template&id=12d826aa"
import script from "./JBProposalStockRecords.vue?vue&type=script&lang=js"
export * from "./JBProposalStockRecords.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports